/* eslint-disable import/order */
import App from '@/App.vue'
import { tooltip } from '@/directives/tooltip'
import i18n from '@/plugins/i18n'
import { ToastPlugin } from '@/plugins/toast'

// Bootstrap for every page, the Tailwind layout (`tw`) included: `body.vh-100`
// is what makes <body> the scroll container. The synchronously imported
// `default` layout used to provide this until INQ-820 removed it, and the
// signed-out landing page was cut off at the first screen.
import '@/assets/styles/styles.scss'
import 'bootstrap'
import router from '@/router'
import { usePriceStore } from '@/stores/price'
import 'vue-final-modal/style.css'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { createVfm } from 'vue-final-modal'
import { createGmapVuePlugin } from '@gmap-vue/v3'
import '@gmap-vue/v3/dist/style.css'
import { createGtm } from '@gtm-support/vue-gtm'

// Create vue app
const app = createApp(App)

// Use plugins
app.use(createPinia())

// Warm the settings singleton (Django admin -> Default price settings),
// which carries the runtime feature switches alongside show_price.
// Deliberately not awaited: nothing should delay first paint. Flags default
// to off until the response lands, and the router guards await the same
// cached promise before deciding whether a gated route may be entered.
usePriceStore().ensureSettingsLoaded()

app.use(router)
app.use(i18n)
app.use(createVfm())
app.use(ToastPlugin)
app.use(createGmapVuePlugin({
  load: {
    key: import.meta.env.VITE_GOOGLE_API_KEY || '',
    libraries: 'places,geometry',
    region: 'EU',
  },
}))

if (import.meta.env.MODE === 'production') {
  app.use(
    createGtm({
      id: import.meta.env.VITE_GTM_ID || 'GTM-UNDEFINED',
      vueRouter: router,
      debug: true,
    }),
  )
}
app.directive('tooltip', tooltip)

app.mount('#app')
